import {ProjectCustomFieldDef, ProjectModel} from '../models/project';

export function getProjectCustomField(project: ProjectModel, internalFieldName: string): ProjectCustomFieldDef | null {
  return project?.customFieldDef.find((f) => f.internalFieldName === internalFieldName);
}
